import React, { Component, Fragment } from "react";
import { inject, observer } from "mobx-react";

import { Grid, Button, TextField ,Typography} from "@material-ui/core";
import ResponsiveTable from "../../components/table/ResponsiveTable";
import SelectField from "../../components/fields/SelectField";
import ConfirmationModal from "../../components/modal/ConfirmationModal";
const ENABLE_XERO = process.env.REACT_APP_ENABLE_XERO === "true";
@inject("authStore", "templateStore", "userStore","profileStore","xeroStore")
@observer
class EmployeeMapping extends Component {
    state = {
        xeroActive: false,
        xeroAccount: "",
        editedId: "",
        updateProcess: false,
        xeroId: "",
        mappedId: "",
        newcontactId:"",
        openRemoveContactModalState: false,
        removedId : null,
        editedXeroId: "",
        confirmNewContactModalState: false
    };
    EmployeeMappingColumn = [
        { key: "Contacts", label: "HG Sole Trader Artists",width:"25%" },
        { key: "xeroEmployees", label: "Xero Employees",width:"30%"  },
        { key: "status", label: "Status",width:"15%"  },
        { key: "action", label: "",width:"30%"  }
    ];
    
    
    EmployeeMappingRows = [];
    componentDidMount = () => {
        let currentProfile = this.props.profileStore.getCurrentProfile();
        if(ENABLE_XERO && currentProfile && currentProfile.activateXeroAccess && currentProfile.xeroTenantId){
            Promise.all([
                this.props.xeroStore.getListXeroMappedEmployees(currentProfile.id),
                this.props.xeroStore.getXeroEmpoyee(currentProfile.id)
            ]).then(() => { 
      
            });
        }
       
    };
    openRemoveContactModal = id => {
        this.setState({
            openRemoveContactModalState: true,
            removedId : id
        });
    };
    closeRemoveContactModal = id => {
        this.setState({
            openRemoveContactModalState: false,
            removedId : null
        });
    };
    handleMappedId = (contactId,xeroId) => {
        this.props.xeroStore.setEditedXeroEmployee(contactId,xeroId)

    }
    setEditedContact = value =>  {
        const { editedXeroId } = this.state
        if(this.state.editedId && !editedXeroId){
            this.props.xeroStore.cancelEditedXeroEmployee(this.state.editedId)
        }
        if(editedXeroId){
            this.props.xeroStore.cancelUpdatedXeroEmployee(this.state.editedId)
        }
        this.setState({
            editedId: value,
            updateProcess: false,
            editedXeroId: ""
        });
    }

    setUpdatedContact = (data) =>  {
        const { editedXeroId } = this.state
        if(this.state.editedId && !editedXeroId){
            this.props.xeroStore.cancelEditedXeroEmployee(this.state.editedId)
        }
        if(editedXeroId){
            this.props.xeroStore.cancelUpdatedXeroEmployee(this.state.editedId)
        }
        this.props.xeroStore.setUpdatedXeroEmployee(data.contactId)
        // this.props.xeroStore.cancelEditedXero(existingUID)
        this.setState({
            editedId: data.contactId,
            editedXeroId: data.employeeId,
            updateProcess: true
        });
    }

    cancelEditedContact = (contactId) =>{
       
        const { editedXeroId } = this.state
        if(editedXeroId){
            this.props.xeroStore.cancelUpdatedXeroEmployee(contactId)
        }else{
            this.props.xeroStore.cancelEditedXeroEmployee(contactId)
        }
        this.setState({
            editedId: "",
            editedXeroId: "",
            updateProcess:false
        });
        
        
    }
    

    handleDeleteContact = () => {
        const { removedId } = this.state
        let currentProfile = this.props.profileStore.getCurrentProfile();
        this.props.templateStore.showLoadingScreen()
        this.props.xeroStore.deleteXeroMappingEmployee(removedId).then(result =>  {
            Promise.all([
                this.props.xeroStore.getListXeroMappedEmployees(currentProfile.id),
                // this.props.xeroStore.getxeroEmployees(currentProfile.id)
            ]).then(() => { 
                this.setState({
                    ...this.state,
                    openRemoveContactModalState: false,
                    removedId: undefined
                });
            });
          
        }).finally(()=> {
            this.props.templateStore.hideLoadingScreen()
           
        })
        
    }

    handleOpenConfirmCreateNewContact = id => {
        this.setState({
            confirmNewContactModalState: true,
            newcontactId: id,
            editedId: "",
            editedXeroId: ""
        });
    };

    handleCloseConfirmNewContactInvitationModal = () => {
        this.setState({
            ...this.state,
            confirmNewContactModalState: false,
            newcontactId: undefined
        });
    };

    saveEditedContact = (mappedId, contactId,xeroId) =>{
        let currentProfile = this.props.profileStore.getCurrentProfile();
        this.props.templateStore.showLoadingScreen()
        if(this.state.updateProcess){
            this.props.xeroStore.updateContactEmployee(mappedId, xeroId).then(result =>  {
                Promise.all([
                    this.props.xeroStore.getListXeroMappedEmployees(currentProfile.id),
                    // this.props.xeroStore.getxeroEmployees(currentProfile.id)
                ]).then(() => { 
                    // this.props.xeroStore.cancelEditedXero(contactId)
                    this.setState({
                        editedId: "",
                        editedXeroId: ""
                    });
                });
              
            }).finally(()=> {
                this.props.templateStore.hideLoadingScreen()
               
            })
        }
        else{
            this.props.xeroStore.mapExistingXeroEmployee(currentProfile.id, contactId, xeroId).then(result =>  {
                Promise.all([
                    this.props.xeroStore.getListXeroMappedEmployees(currentProfile.id),
                    // this.props.xeroStore.getxeroEmployees(currentProfile.id)
                ]).then(() => { 
                    // this.props.xeroStore.cancelEditedXero(contactId)
                    this.setState({
                        editedId: ""
                    });
                });
              
            }).finally(()=> {
                this.props.templateStore.hideLoadingScreen()
               
            })
        }
       
        
    }
    handleCreateNewContact = () => {
        const { newcontactId } = this.state
        let currentProfile = this.props.profileStore.getCurrentProfile();
        this.props.templateStore.showLoadingScreen()
        this.props.xeroStore.createXeroEmployee(currentProfile.id, newcontactId).then(response =>  {
            if (response.status === 401) {
                this.props.templateStore.openSnackbar("You don't have permission for this action");
                return;
            }
            if (response.status === 400) {
                this.props.templateStore.openSnackbar("Create employee error, please verify super annuation data of the musician. If the issue persists, contact support");
                return;
            }
            if (response.status === 200) {
                if (response.data.isError) {
                    this.props.templateStore.openSnackbar(response.data.message);
                    return;
                }
                this.props.templateStore.openSnackbar(`Employee successfully created`);
                Promise.all([
                    this.props.xeroStore.getListXeroMappedEmployees(currentProfile.id),
                    this.props.xeroStore.getXeroEmpoyee(currentProfile.id)
                ]).then(() => { 
                    this.setState({
                        ...this.state,
                        confirmNewContactModalState: false,
                        newcontactId: undefined
                    });
                })
                return;
            }
            this.props.templateStore.openSnackbar("An unexpected error occurred");
        }).catch((error) => {
            this.props.templateStore.openSnackbar(error);
        })
        .finally(()=> {
            this.props.templateStore.hideLoadingScreen()
           
        })
       
    }

    mapContactsToRowData = () => {
        const { listXeroMappedEmployees,xeroEmployees,xeroEmployeesFull } = this.props.xeroStore;
        
        const {editedId} = this.state
        this.EmployeeMappingRows = [];
        console.log(listXeroMappedEmployees)
        listXeroMappedEmployees.forEach(data => {

            var row = {};

            row.Contacts = data.profileName ? data.profileName : data.firstName + " " + data.lastName

            if(data.employeeId && !data.isEdited && !data.isUpdated){
                var existingUID = xeroEmployeesFull.filter(x=>x.value === data.employeeId)
                if(existingUID.length){
                    row.xeroEmployees = <TextField
                    // label="Xero Contact Name"
                    inputProps={{
                        readOnly: true
                    }}
                    value={existingUID[0].label}
                    fullWidth
                />
                }
               
            }else if(data.contactId != editedId){
                row.xeroEmployees = <TextField
                // label="Xero Contact Name"
                inputProps={{
                    readOnly: true
                }}
                value="Map Xero Account"
                fullWidth
            />
            }else{
                row.xeroEmployees =  <SelectField
                id="xeroEmployees"
                value={data.employeeId}
                suggestions={xeroEmployees}
                placeholder="Map Xero Account"
                disabled={data.contactId != editedId}
                onChange={(value) => this.handleMappedId(data.contactId,value)}
            />
            }
            
           
            
           
            row.status = data.employeeId ? ((data.isEdited || data.isUpdated) ? "Confirm?" : "Mapped" ) : "Not Mapped";

            if(data.employeeId && !data.isEdited && !data.isUpdated){
                row.action = (
                    <Fragment>
                         <Button size="small" color="primary" onClick={() => this.setUpdatedContact(data)}>
                            Update
                        </Button>
                        <Button size="small" color="primary" onClick={() => this.openRemoveContactModal(data.mappedId)}>
                            Remove
                        </Button>
                    </Fragment>
                );
    
            }else{
                if(data.isEdited || data.isUpdated){
                    row.action = (
                        <Fragment>
                            <Button size="small" color="primary" onClick={() => this.saveEditedContact(data.mappedId,data.contactId,data.employeeId)}>
                                Save
                            </Button>
                            <Button size="small" color="primary" onClick={() => this.cancelEditedContact(data.contactId)}>
                                Cancel
                            </Button>
                        </Fragment>
                        
                    );
                   
                }else{
                    row.action = (
                        <Fragment>
                            <Button size="small" color="primary" onClick={() => this.setEditedContact(data.contactId)}>
                                Map Existing
                            </Button>
                            <Button size="small" color="primary" onClick={() => this.handleOpenConfirmCreateNewContact(data.contactId)}>
                                Create New
                            </Button>
                        </Fragment>
                        
                    );
                }
                
            }
           
            // row.style = {
            //     backgroundColor: "#FFC0CB"
            // };

            this.EmployeeMappingRows.push(row);
        });
        return Promise.resolve();
    };

    render() {
        this.mapContactsToRowData()
        return (
            <div>
                <Grid item md={12} style={{ marginTop: 25 }}>
                            <Grid container spacing={0}>
                                <Grid item md={12}>
                                    <Grid container spacing={8}>
                                        <Grid item md={3} xs={12}  spacing={0}
                                            direction="column"
                                            alignItems="center"
                                            justify="center" style={{ textAlign: "left", borderRight:"solid 1px"}}>
                                            
                                            <Typography gutterBottom>
                                                Map sole-trader artists to Xero Employees (contractors) so their super from synced invoices lands in the right pay run.
                                            </Typography>
                                        </Grid>
                                        <Grid item md={9} xs={12}  container
                                            spacing={0}
                                            direction="column"
                                            alignItems="center"
                                            justify="center" style={{paddingLeft:"15px",textAlign: "left",verticalAlign:"middle" }}>
                                                
                                                <Grid container spacing={2}>
                                                    <Grid item md={12}>
                                                        <ResponsiveTable
                                                            columns={this.EmployeeMappingColumn}
                                                            rows={this.EmployeeMappingRows}
                                                            showToolbar={true}
                                                            title="Employee Mapping"
                                                            pagination={this.EmployeeMappingRows.length > 5}
                                                        />

                                                    </Grid>  
                                                </Grid>     
                                            </Grid>
                                    </Grid>

                                               
                                </Grid>
                            </Grid>
                            
                        </Grid>

                <ConfirmationModal
                    open={this.state.confirmNewContactModalState}
                    message="Are you sure you want to create a new XERO employee for this contact?"
                    closeHandler={this.handleCloseConfirmNewContactInvitationModal}
                    confirmationHandler={this.handleCreateNewContact}
                    declineHandler={this.handleCloseConfirmNewContactInvitationModal}
                    confirmationLabel="Confirm"
                />
                 <ConfirmationModal
                    open={this.state.openRemoveContactModalState}
                    message="Are you sure you want to remove the existing connection to Xero employee?"
                    closeHandler={this.closeRemoveContactModal}
                    confirmationHandler={this.handleDeleteContact}
                    declineHandler={this.closeRemoveContactModal}
                    confirmationLabel="Confirm"
                />
            </div>
            
        );
    }
}

export default EmployeeMapping;
